export default ({ next, store }) => {
  if (store.getters.me) {
    return next({ name: 'time-log-weekly' })
  }

  return next()
}
